export class EditPasswordCtrl {
    password:string;
    confirmPassword: string;
    public static $inject = ['$scope', '$uibModalInstance'];
    constructor(public $scope:any, public $uibModalInstance:angular.ui.bootstrap.IModalServiceInstance) {
        $scope.vm = this;
    }
    ok() {
        this.$uibModalInstance.close(this.password);
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }
}
